import { Link } from "wouter";
import { ArrowLeft } from "lucide-react";

export function BackButton() {
  return (
    <Link
      href="/"
      className="flex items-center space-x-2 tracking-[0.2em] uppercase text-[10px] font-bold hover:text-[#C06B5D] transition-colors mb-12"
    >
      <ArrowLeft size={14} />
      <span>Back to Directory</span>
    </Link>
  );
}
